import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_SETTINGS } from './API_SETTINGS';
import { CustomerUsageLimit } from '../models/usage/CustomerUsageLimit';
import { CustomerUsage } from '../models/usage/CustomerUsage';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrlUsage = API_SETTINGS.API_URL + 'CustomerUsage';
const apiUrlUsageLimit = API_SETTINGS.API_URL + 'CustomerUsageLimit';

@Injectable({
  providedIn: 'root'
})
export class ApiCustomerUsageService {

  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getCustomerUsageByCustomerId(id: number): Observable<CustomerUsage> {
    const url = `${apiUrlUsage}/GetCustomerUsageByCustomerId/${id}`;
    return this.http.get<CustomerUsage>(url).pipe();
  }

  addCustomerUsage(customerUsage: CustomerUsage): Observable<CustomerUsage>{
    const url = apiUrlUsage + '/AddCustomerUsage';
    return this.http.post<CustomerUsage>(url, customerUsage, httpOptions).pipe(
      catchError(this.handleError<CustomerUsage>('addCustomerUsage'))
    )
  }

  recalculateCustomerUsageByCustomerId(id: number){
    const url = apiUrlUsage + '/RecalculateCustomerUsageByCustomerId';
    return this.http.post<CustomerUsage>(url, id, httpOptions).pipe(
      catchError(this.handleError<CustomerUsage>('recalculateCustomerUsageByCustomerId'))
    )
  }

  getCustomerUsageLimitByCustomerId(id: number): Observable<CustomerUsageLimit> {
    const url = `${apiUrlUsageLimit}/GetCustomerUsageLimitByCustomerId/${id}`;
    return this.http.get<CustomerUsageLimit>(url).pipe();
  }

  postCustomerUsageLimitByCustomerId(customerUsageLimit: CustomerUsageLimit): Observable<CustomerUsageLimit> {
    const url = `${apiUrlUsageLimit}/PostCustomerUsageLimit`;
    return this.http.post<CustomerUsageLimit>(url, customerUsageLimit, httpOptions).pipe(
      catchError(this.handleError<CustomerUsageLimit>('addCustomerUsageLimit'))
    )
  }
}